<div #pdfViewerContainer class="signtrust-pdf-viewer-container">
  <div class="pdfViewer"></div>
</div>
